import { useEffect } from "react";

const getStorageKey = (vehicleGroupId) => `vehicleConfig_${vehicleGroupId}`;

/**
 * Carrega o estado persistido no localStorage para um grupo de veículos.
 * Chamado uma vez antes da montagem do componente (fora de hooks).
 *
 * @param {string|number} vehicleGroupId
 * @returns {object} Estado salvo, ou {} se não houver
 */
export function loadVehicleConfigState(vehicleGroupId) {
  const savedState = localStorage.getItem(getStorageKey(vehicleGroupId));
  if (savedState) {
    return JSON.parse(savedState);
  }
  return {};
}

/**
 * Persiste o estado do formulário no localStorage sempre que algum
 * dos seus campos mudar.
 *
 * @param {string|number} vehicleGroupId
 * @param {object} state - Todos os slices do formulário
 */
export function useVehicleConfigStorage(vehicleGroupId, {
  selectedId,
  selectedColor,
  kmzFlag,
  fenceFlag,
  visitFlag,
  riskAreaFlag,
  strechesFlag,
  relatorios,
  archives,
  movementForm,
  speedForm,
  reportConfigPayload,
}) {
  useEffect(() => {
    if (!vehicleGroupId) return;
    const stateToSave = {
      selectedId,
      selectedColor,
      kmzFlag,
      fenceFlag,
      visitFlag,
      riskAreaFlag,
      strechesFlag,
      relatorios,
      archives,
      movementForm,
      speedForm,
      reportConfigPayload,
    };
    localStorage.setItem(getStorageKey(vehicleGroupId), JSON.stringify(stateToSave));
  }, [
    vehicleGroupId,
    selectedId,
    selectedColor,
    kmzFlag,
    fenceFlag,
    visitFlag,
    riskAreaFlag,
    strechesFlag,
    relatorios,
    archives,
    movementForm,
    speedForm,
    reportConfigPayload,
  ]);
}
